/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import { SalesInvoice, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getSimpleProductsAction, ProductInput } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';

import { IInvoiceDetailsViewProps } from '@msdyn365-commerce-modules/invoice-details/src/modules/invoice-details/./invoice-details';
import { InvoiceDetailsProductsComponent, InvoiceDetailsModel } from './components/invoice-details-products.component';



export const InvoiceDetailsView: React.FC<IInvoiceDetailsViewProps> = props => {
    const {
        config,
        header,
        /*products,*/
        paymentDetails,
        payInvoiceError,
        context,
        resources,
        typeName
    } = props;
    const baseClassName: string = 'msc-invoice-details';
    const [invoiceDetails, setInvoiceDetails] = React.useState<InvoiceDetailsModel>();
    const [products, setProducts] = React.useState<SimpleProduct[]>([]);

    const getInvoiceDetails = async (): Promise<SalesInvoice> => {
        const invoice = await props.data.invoice;
        const invDetails = await props.data.invoiceDetails;
        const invoiceDetailsModel = new InvoiceDetailsModel(invoice, invDetails, products);
        setInvoiceDetails(invoiceDetailsModel);
        return invDetails;
    };

    const getProducts = async (channelId?: number): Promise<SimpleProduct[]> => {
        const invDetails = await getInvoiceDetails();
        const invoiceLines = invDetails.SalesInvoiceLine || [];
        const productInputs = invoiceLines.filter(product => product.RecordId).map(product => new ProductInput(
            product.RecordId!, context.request.apiSettings, channelId, undefined, context.actionContext.requestContext));
        const simpleProductsRes = await getSimpleProductsAction(productInputs, context.actionContext);
        setProducts(simpleProductsRes);
        return getSimpleProductsAction(productInputs, context.actionContext);
    }

    const renderProducts = (): JSX.Element | null => {
        const { imageSettings } = config;

        if (!invoiceDetails) {
            return null;
        }

        return (
            <InvoiceDetailsProductsComponent
                className={`${baseClassName}__products`}
                id={`${baseClassName}__${invoiceDetails.id}`}
                data={{ invoiceDetails }}
                typeName={typeName}
                context={context}
                resources={resources}
                imageSettings={imageSettings}
            />
        );
    }

    React.useEffect(() => {
        void getProducts();
    }, []);
    
    return (
        <Module {...props.moduleProps}>
            {header}
            {/* {products} */}
            {renderProducts()}
            {paymentDetails}
            {payInvoiceError}
        </Module>
    );
};

export default InvoiceDetailsView;
